// CourtListener SDK
export * from './api/client';

// Generated API functions and types
export * from './api/generated/endpoints';
export type * from './api/generated/model';

export default {
  name: 'CourtListener SDK',
  version: '1.0.0',
  description: 'TypeScript SDK and MCP server for the CourtListener API',
};
